import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Inbox, Rss, ScrollText, SlidersHorizontal, AlertTriangle, Layers, Globe,
} from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import ModuleSwitcher from "@/components/ModuleSwitcher";
import IOSInstallBanner from "@/components/IOSInstallBanner";

const PRODUCTION_TABS = [
  { to: "/", icon: Inbox, label: "File", testid: "tab-queue", exact: true },
  { to: "/flux", icon: Rss, label: "Flux", testid: "tab-feeds" },
  { to: "/sites", icon: Globe, label: "Sites", testid: "tab-sites" },
  { to: "/journal", icon: ScrollText, label: "Journal", testid: "tab-logs" },
  { to: "/reglages", icon: SlidersHorizontal, label: "Réglages", testid: "tab-settings" },
];

const POLITICS_TABS = [
  { to: "/veille", icon: AlertTriangle, label: "Alertes", testid: "tab-politics-alerts", exact: true },
  { to: "/veille/categories", icon: Layers, label: "Catégories", testid: "tab-politics-cats" },
  { to: "/veille/flux", icon: Rss, label: "Flux", testid: "tab-politics-feeds" },
  { to: "/veille/reglages", icon: SlidersHorizontal, label: "Réglages", testid: "tab-politics-settings" },
];

export default function AppLayout({ children }) {
  const { pathname } = useLocation();
  const isPolitics = pathname.startsWith("/veille");
  const tabs = isPolitics ? POLITICS_TABS : PRODUCTION_TABS;
  const gridCols = tabs.length === 5 ? "grid-cols-5"
                 : tabs.length === 4 ? "grid-cols-4" : "grid-cols-3";

  return (
    <div className="min-h-screen bg-[var(--bg-app)] flex flex-col" data-testid="app-shell">
      <ModuleSwitcher />
      {isPolitics && <IOSInstallBanner />}
      <div className="flex-1 pb-[76px] max-w-2xl w-full mx-auto">
        {children}
      </div>

      <nav
        className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-[var(--border-default)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom)", zIndex: 100000 }}
        data-testid="bottom-nav"
      >
        <div className={`max-w-2xl mx-auto grid ${gridCols}`}>
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.exact}
                data-testid={t.testid}
                className={({ isActive }) =>
                  [
                    "relative flex flex-col items-center justify-center gap-1 py-3 min-h-[64px] text-[11px] font-medium tracking-wide transition-colors",
                    isActive ? "text-black" : "text-[var(--text-muted)] hover:text-black",
                  ].join(" ")
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span
                        className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[2px] bg-black"
                        aria-hidden
                      />
                    )}
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                    <span>{t.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>

      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: "2px",
            border: "1px solid #111",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
